    <form [formGroup]="customerForm" (ngSubmit)="onSubmit()" class="grid grid-cols-2 gap-4">
      <!-- Basic Info -->
      <div>
        <label for="first_name">First Name</label>
        <input type="text" id="first_name" formControlName="first_name">
        <div *ngIf="customerForm.get('first_name')?.invalid && customerForm.get('first_name')?.touched">
          First Name is required.
        </div>
      </div>
      <div>
        <label for="last_name">Last Name</label>
        <input type="text" id="last_name" formControlName="last_name">
        <div *ngIf="customerForm.get('last_name')?.invalid && customerForm.get('last_name')?.touched">
          Last Name is required.
        </div>
      </div>
      <div>
        <label for="email">Email</label>
        <input type="email" id="email" formControlName="email">
        <div *ngIf="customerForm.get('email')?.invalid && customerForm.get('email')?.touched">
          <div *ngIf="customerForm.get('email')?.errors?.['required']">Email is required.</div>
          <div *ngIf="customerForm.get('email')?.errors?.['email']">Invalid email.</div>
        </div>
      </div>
      <div>
        <label for="phone_number">Phone Number</label>
        <input type="text" id="phone_number" formControlName="phone_number">
      </div>

      <!-- Customer Key -->
      <div>
        <label for="customer_id">Customer ID</label>
        <input type="text" id="customer_id" formControlName="customer_id">
        <div *ngIf="customerForm.get('customer_id')?.invalid && customerForm.get('customer_id')?.touched">
          Customer ID is required.
        </div>
      </div>

      <!-- Geographical Info -->
      <div>
        <label for="id">ID</label>
        <input type="text" id="id" formControlName="id">
        <div *ngIf="customerForm.get('id')?.invalid && customerForm.get('id')?.touched">
          ID is required.
        </div>
      </div>
      <div>
        <label for="name">Name</label>
        <input type="text" id="name" formControlName="name">
      </div>
      <div>
        <label for="latitude">Latitude</label>
        <input type="number" id="latitude" formControlName="latitude">
      </div>
      <div>
        <label for="longitude">Longitude</label>
        <input type="number" id="longitude" formControlName="longitude">
      </div>

      <!-- Other Details -->
      <div>
        <label for="status">Status</label>
        <select id="status" formControlName="status">
          <option *ngFor="let status of customerStatuses" [value]="status">{{ status }}</option>
        </select>
        <div *ngIf="customerForm.get('status')?.invalid && customerForm.get('status')?.touched">
          Status is required.
        </div>
      </div>
      <div>
        <label for="activation_date">Activation Date</label>
        <input type="number" id="activation_date" formControlName="activation_date">  <!-- Consider using a date picker -->
        <div *ngIf="customerForm.get('activation_date')?.invalid && customerForm.get('activation_date')?.touched">
          Activation Date is required.
        </div>
      </div>
      <div>
        <label for="autopay_status">Autopay Status</label>
        <input type="checkbox" id="autopay_status" formControlName="autopay_status">
        <div *ngIf="customerForm.get('autopay_status')?.invalid && customerForm.get('autopay_status')?.touched">
          Autopay Status is required.
        </div>
      </div>

      <!-- Mailing Address (Example) - Adapt based on IObjectAddress -->
      <div formGroupName="mailing_address">
        <div>
          <label for="mailing_address_street">Mailing Address Street</label>
          <input type="text" id="mailing_address_street" formControlName="street">
        </div>
        <!-- Add other mailing address fields similarly -->
      </div>

      <div>
        <label for="token_uid">Token UID</label>
        <input type="text" id="token_uid" formControlName="token_uid">
        <div *ngIf="customerForm.get('token_uid')?.invalid && customerForm.get('token_uid')?.touched">
          Token UID is required.
        </div>
      </div>
      <div>
        <label for="total_balance">Total Balance</label>
        <input type="number" id="total_balance" formControlName="total_balance">
        <div *ngIf="customerForm.get('total_balance')?.invalid && customerForm.get('total_balance')?.touched">
          Total Balance is required.
        </div>
      </div>
      <div>
        <label for="total_subscriptions">Total Subscriptions</label>
        <input type="number" id="total_subscriptions" formControlName="total_subscriptions">
        <div *ngIf="customerForm.get('total_subscriptions')?.invalid && customerForm.get('total_subscriptions')?.touched">
          Total Subscriptions is required.
        </div>
      </div>
      <div>
        <label for="last_payment_attempt">Last Payment Attempt</label>
        <input type="number" id="last_payment_attempt" formControlName="last_payment_attempt">
        <div *ngIf="customerForm.get('last_payment_attempt')?.invalid && customerForm.get('last_payment_attempt')?.touched">
          Last Payment Attempt is required.
        </div>
      </div>

      <button type="submit" [disabled]="customerForm.invalid">Submit</button>
    </form>